import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { NEVER } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ACTING_INVALID_CODES, ACTING_LEVEL_DENIED } from '../acting/acting-brand.model';
import { ActingBrandService } from '../acting/acting-brand.service';
import { ToastService } from '../services/toast.service';

export const actingBrandInterceptor: HttpInterceptorFn = (request, next) => {
  const acting = inject(ActingBrandService);
  const toast = inject(ToastService);
  if (acting.targetId === null || !request.url.startsWith(environment.apiServerUrl)) return next(request);
  const path = request.url.slice(environment.apiServerUrl.length).split(/[?#]/)[0];
  if (path.startsWith('/oauth') || path.startsWith('/s8/') || path === '/api/account/acting-targets') {
    return next(request);
  }
  const id = String(acting.targetId);
  return next(request.clone({ setHeaders: { 'X-Acting-Brand-Id': id, 'Brand-Id': id } })).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 403) {
        const code: unknown = error.error?.code;
        if (typeof code === 'string' && ACTING_INVALID_CODES.includes(code)) {
          // 이동하면 지금 띄운 토스트가 사라지므로 안내는 이동한 화면에서 띄운다(acting-banner showNotice)
          acting.exit('invalid');
          // 전체 이동 중이므로 오류를 흘리지 않는다 — 던지면 auth.guard 가 /logout 으로 보내 로그인이 풀린다
          return NEVER;
        } else if (code === ACTING_LEVEL_DENIED && request.method !== 'GET') {
          // 조회(GET) 거부는 화면이 허용표 밖 데이터를 부른 것이라 토스트로 쏟아내지 않는다(S4 허용표 확장 후속)
          toast.showToast('actingBrand.error.levelDenied').subscribe();
        }
      }
      throw error;
    }),
  );
};
